
import LoginForm from "../application/forms/LoginForm.vue";
import RegisterModal from "./RegisterModal.vue";
import { ref } from "vue";
import {disableBodyOverflow, enableBodyOverflow} from "../mixins";

export default {
  components: {
    RegisterModal,
    "login-form": LoginForm
  },
  setup() {
    const isRegisterModalOpen = ref(false);

    const toggleRegisterModal = () => {
      isRegisterModalOpen.value = !isRegisterModalOpen.value;

      if (isRegisterModalOpen.value) {
        disableBodyOverflow();
      } else {
        enableBodyOverflow();
      }
    };

    return {
      isRegisterModalOpen,
      toggleRegisterModal
    };
  }
};
